// Smarticks: the dashboard ships Hebrew and English only.
//
// Upstream imports 40 locale directories here and Vite bundles every one of them into a single
// chunk the browser must download before the app boots. Measured on hd (production): 11.76 MB on a
// cold load, of which 14.1 MB raw is this JSON. Every fleet server runs he, with one en account and
// one en agent; across all 12 servers and 87 users there is not a single other language in use.
//
// 🔴 Keep this list in step with Custom::ApplicationHelper::DASHBOARD_LOCALES, which is what the
// language picker offers. spec/custom/config/dashboard_locales_spec.rb fails if they drift — and
// they HAD drifted upstream: `et` was offered by the picker with no messages bundled at all, and
// `hi` was bundled but never offered.
//
// The widget and the survey keep their own full sets; they are separate bundles.
import en from './locale/en';
import he from './locale/he';

export default {
  en,
  he,
};
